import * as React from "react";
import { useTranslation } from "react-i18next";
import AppBar from "@mui/material/AppBar";

import Toolbar from "@mui/material/Toolbar";

import Container from "@mui/material/Container";
// @ts-ignore - side-effect CSS import is used to ensure styles load when this component is tested in isolation.
import "../styles.css";
  
import { ReactComponent as PGEIcon } from "../../Assets/PGElogo.svg";

export const ClaimsHeader: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e: any) => {
    i18n.changeLanguage(e.target.value);
  };
  return (
    <AppBar
      position="static"
      style={{
        backgroundColor: "white",
        paddingTop: "30px",
        paddingBottom: "5px",
      }}
      className="mobileBar"
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <a href="https://www.pge.com/" aria-label="PG&E Home" className="floatLeft">
            <PGEIcon />
          </a>
          <div className="floatRight">
          <i className="icon icon--globe" aria-hidden="true"></i>     
          <select value={i18n.language} onChange={handleLanguageChange} className="langdrpdwn">
          <option value="en">English</option>
          <option value="es">Español</option>
          <option value="zh">中国人</option>
          </select>
          </div>
        </Toolbar>
      </Container>      
        
    </AppBar>   
  );
};

export default ClaimsHeader;
